var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar"},[_c('router-link',{staticClass:"tab",attrs:{"data-text":"Open","to":{
        name: 'ShowCapsule',
        params: { capsuleId: _vm.outfit.capsule_id },
        query: _vm.queryParams
      }}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"pe-7s-look"})])]),_vm._v(" "),_c('b-link',{staticClass:"tab",attrs:{"data-text":"Remove"},on:{"click":_vm.showUnstitchOutfitModal}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"pe-7s-trash"})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77dff312","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stitchedOutfits/Actions.vue
// module id = L/aK
// module chunks = 0